<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />
        <Privilege :v="$v.egrnConfirmDetails" />
      </div>

      <Footer
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';

import { getValidationErrorText } from '@/utils/validate';
import { checkInvalid, leaveStep, Text } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import Privilege, {
  privilegeModel,
  privilegeValidation,
} from '@/components/services/elements/Privilege';
import deepmerge from 'deepmerge';
import { EgrnConfirmStep } from '@/constants';

export default {
  name: 'RefundDetails',
  components: {
    Footer,
    BankDetails,
    Privilege,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    Text,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: cloneDeep(bankDetails),
    egrnConfirmDetails: cloneDeep(privilegeModel),
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      egrnConfirmDetails: privilegeValidation,
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const bankDetails = ServicesModule.statement.accountBankDetails;
      const egrnConfirmDetails = ServicesModule.statement.egrnConfirmDetails;

      if (bankDetails) {
        this.accountBankDetails = deepmerge(
          this.accountBankDetails,
          bankDetails
        );
      }

      if (egrnConfirmDetails) {
        this.egrnConfirmDetails = deepmerge(
          this.egrnConfirmDetails,
          egrnConfirmDetails
        );
      }
    },

    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return {
        accountBankDetails: cloneDeep(this.accountBankDetails),
        egrnConfirmDetails: cloneDeep(this.egrnConfirmDetails),
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: EgrnConfirmStep.REFUND_DETAILS,
      });
    },
  },
};
</script>
